module.exports = require("@pb/kit-util-get-width-of-text");